var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1872_124",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#F8153B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1872_124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.833252 16.6667V14.3333C0.833252 13.8611 0.95478 13.4271 1.19784 13.0313C1.44089 12.6354 1.76381 12.3333 2.16659 12.125C3.0277 11.6945 3.9027 11.3715 4.79159 11.1563C5.68047 10.941 6.58325 10.8333 7.49992 10.8333C8.41659 10.8333 9.31936 10.941 10.2083 11.1563C11.0971 11.3715 11.9721 11.6945 12.8333 12.125C13.236 12.3333 13.5589 12.6354 13.802 13.0313C14.0451 13.4271 14.1666 13.8611 14.1666 14.3333V16.6667H0.833252ZM15.8333 16.6667V14.1667C15.8333 13.5556 15.6631 12.9688 15.3228 12.4063C14.9826 11.8438 14.4999 11.3611 13.8749 10.9583C14.5833 11.0417 15.2499 11.184 15.8749 11.3854C16.4999 11.5868 17.0833 11.8333 17.6249 12.125C18.1249 12.4028 18.5069 12.7118 18.7708 13.0521C19.0346 13.3924 19.1666 13.7639 19.1666 14.1667V16.6667H15.8333ZM7.49992 10C6.58325 10 5.79853 9.67362 5.14575 9.02084C4.49297 8.36807 4.16659 7.58334 4.16659 6.66668C4.16659 5.75001 4.49297 4.96529 5.14575 4.31251C5.79853 3.65973 6.58325 3.33334 7.49992 3.33334C8.41659 3.33334 9.20131 3.65973 9.85409 4.31251C10.5069 4.96529 10.8333 5.75001 10.8333 6.66668C10.8333 7.58334 10.5069 8.36807 9.85409 9.02084C9.20131 9.67362 8.41659 10 7.49992 10ZM15.8333 6.66668C15.8333 7.58334 15.5069 8.36807 14.8541 9.02084C14.2013 9.67362 13.4166 10 12.4999 10C12.3471 10 12.1527 9.98265 11.9166 9.94793C11.6805 9.9132 11.486 9.87501 11.3333 9.83334C11.7083 9.3889 11.9964 8.89584 12.1978 8.35418C12.3992 7.81251 12.4999 7.25001 12.4999 6.66668C12.4999 6.08334 12.3992 5.52084 12.1978 4.97918C11.9964 4.43751 11.7083 3.94445 11.3333 3.50001C11.5277 3.43057 11.7221 3.38543 11.9166 3.36459C12.111 3.34376 12.3055 3.33334 12.4999 3.33334C13.4166 3.33334 14.2013 3.65973 14.8541 4.31251C15.5069 4.96529 15.8333 5.75001 15.8333 6.66668Z",
    fill: "#F8153B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.6344c1053e7d04dc5cb7adc6e40c15b2.svg";
export { ForwardRef as ReactComponent };